/**
 * Configuration for localization resources.
 * This file maps locales to their respective translation files and provides a method
 * to dynamically load translations based on the requested locale.
 */

// Mapping of locales to their relative paths.
const config = {
  en: "en/translation.json",
  nl: "nl/translation.json",
  ar: "ar/translation.json",
  ja: "ja/translation.json",
  de: "de/translation.json",
  es: "es/translation.json",
  fr: "fr/translation.json",
  it: "it/translation.json",
  ko: "ko/translation.json",
  pt: "pt/translation.json",
  tr: "tr/translation.json",
  uk: "uk/translation.json",
  vi: "vi/translation.json",
  zh: "zh/translation.json",
  zu: "zu/translation.json",
};

/**
 * Dynamically fetches the translation for the given locale.
 *
 * @param {string} locale - The desired locale for translations.
 * @returns {Promise<object>} - A promise that resolves with the locale and its messages.
 */
export const fetchTranslations = async (locale) => {
  // Check if the provided locale is available in the config resources. If not, default to English.
  const availableLocale = config[locale] ? locale : "en";

  // Dynamically import the required translation file.
  const messages = await import(`./${config[availableLocale]}`);

  return {
    locale: availableLocale,
    messages,
  };
};
